<template>
  <div>
    <v-toolbar class="secondary">
      <v-toolbar-title class="title white--text">Contact Information</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="changeContact" @click="changeContactDialog">Change Customer</v-btn>
    </v-toolbar>
    <v-card v-if="contact">
      <!-- Contact 1 Header -->
      <v-layout align-center row class="primary white--text mb-0">
      <v-flex>
        <v-icon medium dark class="ml-2">{{ contact.type === 'Customer' ? 'person' : 'person_outline' }}</v-icon>
        <span class="headline ml-2">{{ contact.first_name ? contact.first_name + ' ' +  contact.last_name : 'No Contact Assigned' }}</span>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex class="text-xs-right mt-2 pt-0">
        <v-btn v-if="contact.type !== 'Builder'" dark flat @click="editContactDialog = true" small><v-icon left>edit</v-icon>Edit</v-btn>
        <v-btn v-if="contact.type === 'Builder'" dark flat @click="newDialog" small><v-icon left>edit</v-icon>Create Customer</v-btn>
      </v-flex>
      </v-layout>
      <v-layout row class="tertiary" v-if="assigned">
        <v-flex>
          <p class="caption white--text pl-2">Lead Assigned To:</p>
        </v-flex>
      </v-layout>
      <v-list>
        <!-- Contact 1 Phone -->
        <v-list-tile @click="contactLinks('phone', contact.phone_1)" v-if="contact.phone_1">
          <v-list-tile-action>
            <v-icon color="primary">phone</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="title">
            <v-list-tile-title>{{ formatPhoneNumber(contact.phone_1) }}</v-list-tile-title>
            <v-list-tile-sub-title class="mt-1">{{ contact.phone_type_1 }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="contactLinks('phone', contact.phone_2)" v-if="contact.phone_2" class="mt-2">
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="title">{{ formatPhoneNumber(contact.phone_2) }}</v-list-tile-title>
            <v-list-tile-sub-title class="mt-1">{{ contact.phone_type_2 }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <!-- Contact 1 Email -->
          <v-list-tile @click="contactLinks('email', contact.email)" v-if="contact.email">
            <v-list-tile-action>
              <v-icon color="primary">mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="title">{{ contact.email }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        <!-- Contact 2 Header -->
        <div v-if="contact.secondaryContact_first_name" class="primary white--text pt-1 pb-2">
          <v-icon medium dark class="ml-2 mt-2">{{ contact.type === 'Customer' ? 'person' : 'person_outline' }}</v-icon>
          <span class="headline ml-2">{{ contact.secondaryContact_first_name }} {{ contact.secondaryContact_last_name }}</span></div>
        <!-- Contact 2 Phone -->
        <v-list-tile class="mt-2" @click="contactLinks('phone', contact.secondaryContact_phone_1)" v-if="contact.secondaryContact_phone_1">
          <v-list-tile-action>
            <v-icon color="primary">phone</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="title">{{ formatPhoneNumber(contact.secondaryContact_phone_1) }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ contact.phone_type_1 }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="contactLinks('phone', contact.secondaryContact_phone_2)" v-if="contact.secondaryContact_phone_2">
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="title">{{ formatPhoneNumber(contact.secondaryContact_phone_2) }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ contact.secondaryContact_phone_type_2 }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <!-- Contact 2 Email -->
        <v-list-tile @click="contactLinks('email', contact.secondaryContact_email)" v-if="contact.secondaryContact_email">
          <v-list-tile-action>
            <v-icon color="primary">mail</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="title">{{ contact.secondaryContact_email }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <!-- Address Information -->
        <div v-if="contact.address" class="primary white--text pt-1 pb-1">
          <v-icon medium dark class="ml-2">location_on</v-icon>
        <span class="headline ml-2">Customer Address</span></div>
        <v-list-tile @click="contactLinks('address', contact.address + '-' + contact.zip)" v-if="contact.address">
          <v-list-tile-action>
            <v-icon color="indigo">location_on</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ contact.address }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ contact.city }}, {{ contact.state }} {{ contact.zip }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
    <v-toolbar flat color="secondary">
      <v-spacer></v-spacer>
      <v-btn @click="closeDialog" class="primary">Close</v-btn>
    </v-toolbar>
  <!-- Edit Contact Dialog -->
    <v-dialog max-width="600px" persistent v-model="editContactDialog">
      <edit-contact :editContact="contact" v-if="editContactDialog" @closeDialog="editContactDialog = false" @contactChange="contactChange"/>
    </v-dialog>
  <!-- End: Edit Contact Dialog -->
  <!-- Create Contact Dialog -->
    <v-dialog max-width="600px" persistent v-model="createContactDialog">
      <create-contact :isBuilderToContact="true" :builderToCustomerProjectData="project" :builderToCustomerContactData="contact" v-if="createContactDialog" @closeCreateDialog="createContactDialog = false" @contactChange="contactChange" @builderToCustomerChange="builderToCustomerChange"/>
    </v-dialog>
  <!-- End: Create Contact Dialog -->
  </div>
</template>

<script>
import EditContact from './EditContact'
import CreateContact from './CreateContact'

export default {
  props: ['projectContact', 'changeContact', 'project'],
  data () {
    return {
      contact: null,
      editContactDialog: false,
      createContactDialog: false,
      projects: null,
      assigned: null
    }
  },
  mounted () {
    this.contact = this.projectContact
  },
  methods: {
    newDialog () {
      this.createContactDialog = true
    },
    builderToCustomerChange (value) {
      this.contact = value
      this.$emit('builderToCustomerChange', value)
    },
    changeContactDialog () {
      this.$emit('changeContactDialog')
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    formatPhoneNumber (value) {
      let s2 = ('' + value).replace(/\D/g, '')
      let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/)
      return (!m) ? null : '(' + m[1] + ')' + ' ' + m[2] + '-' + m[3]
    },
    contactLinks (type, value) {
      // window.open('mailto: ' + value)
      if (type === 'email') {
        location.href = 'mailto: ' + value
      }
      if (type === 'phone') {
        location.href = 'tel:' + value
      }
      if (type === 'address') {
        window.open('https://www.google.com/maps?q=' + value)
      }
    },
    contactChange (value) {
      this.$emit('contactProjectChange', value)
    }
  },
  components: {
    EditContact, CreateContact
  }
}
</script>

<style>
.metrics {
  margin-bottom: 0px !important;
}
.w3-light-grey,
.w3-hover-light-grey:hover,
.w3-light-gray,
.w3-hover-light-gray:hover {
  color: #000 !important;
  background-color: #f1f1f1 !important;
  width: 100%;
}
.w3-round-xlarge {
  border-radius: 16px;
}
.w3-blue,
.w3-hover-blue:hover {
  color: #fff !important;
  background-color: #2196f3 !important;
}
.w3-container,
.w3-panel {
  padding: 0.01em 16px;
}
.w3-round-xlarge {
  border-radius: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/contacts/ContactDialog.vue